export const model = {
  id: null,
  name: '',
  company_id: null,
  branch_id: null,
  created_at: '',
  updated_at: '',
};
